(function ($) {
  Drupal.behaviors.contactUsForm = {
    attach: function (context) {
      var inputs;

      $('#edit-form-first-name', context).attr(
        'placeholder',
        $('#edit-form-first-name', context).prev('label').text()
      );
      $('#edit-form-last-name', context).attr(
        'placeholder',
        $('#edit-form-last-name', context).prev('label').text()
      );
      $('#edit-form-email-address', context).attr(
        'placeholder',
        $('#edit-form-email-address', context).prev('label').text()
      );
      $('#edit-form-comments', context).attr(
        'placeholder',
        $('#edit-form-comments', context).parent().prev('label').text()
      );
      $('#edit-form-comments', context).parent().prev('label').hide();

      inputs = $(
        'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"], textarea',
        context
      ).not('.no-adpl');

      if (Drupal.behaviors?.adaptivePlaceholders) {
        Drupal.behaviors.adaptivePlaceholders.setupDOM(inputs);
      }
    }
  };
})(jQuery);
